import { apiCall, ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { GenericOrderBy } from '../../../components/_EOS/Table/types'
import { AsnDetailExtended } from '../types'
import { EnumTypeProcessAsn } from '../../../interfaces/Asn/TypeAsnProcess'
import { EnumTypeAsnIncome } from '../../../interfaces/Asn/TypeAsnIncome'
import { utcIntialDate, utcFinalDate } from '../../../utils/dateHelper'

// Mapeo de keys frontend (camelCase) a backend (PascalCase)
const filterKeyMapping: Record<string, string> = {
  asnId: 'AsnId',
  brandId: 'BrandId',
  asnNumber: 'AsnNumber',
  lpn: 'Lpn',
  sku: 'Sku',
  asnStateId: 'AsnStateId',
  lpnStateId: 'LpnStateId',
  batchNumber: 'BatchNumber',
  detailAsnStateId: 'DetailAsnStateId',
  withAdjustments: 'WithAdjustments'
}

export const getAsnDetails = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<AsnDetailExtended>
) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  // Filtros fijos: solo Inbound (no devoluciones) y solo Fulfillment
  queryParams.append('typeAsnProcessId', EnumTypeProcessAsn.Inbound.toString())
  queryParams.append('typeAsnIncomeId', EnumTypeAsnIncome.Fulfillment.toString())

  // Procesar filtros dinámicos
  filters.forEach((filter) => {
    // Manejo especial para rangos de fechas
    if (
      filter.key === 'createdDateRange' ||
      filter.key === 'expirationDateRange'
    ) {
      try {
        const dateRange = JSON.parse(filter.value)
        const isCreatedDate = filter.key === 'createdDateRange'

        if (dateRange.initialCreatedDate) {
          queryParams.append(
            isCreatedDate ? 'initialCreatedDate' : 'ExpirationDateInitial',
            utcIntialDate(dateRange.initialCreatedDate)
          )
        }
        if (dateRange.finalCreatedDate) {
          queryParams.append(
            isCreatedDate ? 'finalCreatedDate' : 'ExpirationDateFinal',
            utcFinalDate(dateRange.finalCreatedDate)
          )
        }
      } catch (error) {
        // Ignorar error de parseo
      }
      return
    }

    // No agregar los filtros fijos si ya vienen en los filtros
    if (filter.key === 'typeAsnProcessId' || filter.key === 'typeAsnIncomeId') {
      return
    }

    // Convertir key a PascalCase usando el mapeo
    const backendKey = filterKeyMapping[filter.key] || filter.key
    queryParams.append(backendKey, filter.value)
  })

  // Ordenamiento
  if (orderBy) {
    const sorters = {
      datafield: orderBy.field.toString(),
      sortOrder: orderBy.direction
    }
    queryParams.append('sorters', JSON.stringify(sorters))
  }

  // Usar el endpoint de AsnDetail
  return apiCall('GET', `${ApiConfig.AsnDetailApi}?${queryParams.toString()}`)
}

export const getAsnDetailState = (asnDetailId: number) => {
  return apiCall('GET', `${ApiConfig.AsnDetailApi}/${asnDetailId}/state`)
}
